var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.712 16.87a.645.645 0 01.632-.657h.008c.36.002.65.296.648.656v6.464a.66.66 0 01-.648.667H.639A.653.653 0 010 23.334V16.87a.645.645 0 01.632-.658h.007c.36.002.65.296.649.656v5.807h21.424V16.87zm-4.538-4.311a.671.671 0 000-.94.617.617 0 00-.872-.032l-.032.032-4.63 4.754V.667A.653.653 0 0012.002 0H12a.66.66 0 00-.649.667v15.706l-4.62-4.754a.627.627 0 00-.887-.026l-.027.026a.671.671 0 000 .94l5.726 5.89a.643.643 0 00.91.004l.004-.005 5.716-5.89z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
export default SvgDownload;